import type { BasicProps } from 'quarks/interpolations/basic';

import richTextParser from 'utils/richTextParser';

import type { FC } from 'react';

interface RichTextProps extends BasicProps {
  content?: {
    raw: string | null;
  };
}

const RichText: FC<RichTextProps> = ({ content }) => {
  const coverContent = content?.raw
    ? content
    : {
        raw: content ? JSON.stringify(content) : null,
      };

  return <>{richTextParser(coverContent)}</>;
};

export default RichText;
